import RestApi from "./RestApi";

export default
{
    list: async function(params) { return RestApi.get("/city", params); },
}
